import { type EnumFrontendLayoutSetting } from '@Model';
import { useTableLayoutFromSettings } from '@Hooks/index';
import { useIsPortalSession } from '@Contexts/session';
import {
    TableWithStoredSettings,
    type IId,
    type ITableWithStoredSettingsProps,
    type ToolbarOptions,
} from '@synqo/frontend-component-library';
import { useToolbarElementsWithout } from './useToolbarElementsWithout';

const HIDE_ADD: ToolbarOptions[] = ['add'];

export interface TableWithStoredSettingsAndLayoutSettingsProps<TItem extends IId>
    extends ITableWithStoredSettingsProps<TItem> {
    layoutSettingsContext: EnumFrontendLayoutSetting;
}

export function TableWithStoredSettingsAndLayoutSettings<TItem extends IId>({
    layoutSettingsContext,
    ...props
}: TableWithStoredSettingsAndLayoutSettingsProps<TItem>) {
    const { columnSizing, columnVisibility, updateSizing, updateVisibility } = useTableLayoutFromSettings(
        layoutSettingsContext,
        props.columns,
    );

    const isPortalSession = useIsPortalSession();
    // A portal user cannot gain create rights from inside the portal, so the button would stay
    // locked forever.
    const toolbarElements = useToolbarElementsWithout(
        props.toolbarElements,
        isPortalSession && !props.canCreate ? HIDE_ADD : undefined,
    );

    return (
        <TableWithStoredSettings
            columnSizing={columnSizing}
            columnVisibility={columnVisibility}
            onSizesChange={updateSizing}
            onVisibilityChange={updateVisibility}
            {...props}
            toolbarElements={toolbarElements}
        />
    );
}
